/**
 * 简易事件分发器
 */
export class SimpleEvent {
  constructor() {
    this.cb = {};
  }

  /**
   * 监听事件
   * @param {string} eventName
   * @param {Function} cb 回调
   */
  on(eventName, cb) {
    if (typeof cb !== "function") {
      console.warn(
        `Event on ${eventName} failed , Parameter 'callback' expects to get a function, actually get ${typeof cb}`
      );
      return;
    }
    const cbList = this.cb[eventName];
    if (cbList) {
      cbList.push(cb);
    } else {
      this.cb[eventName] = [cb];
    }
  }

  /**
   * 取消绑定事件
   * @param {string} eventName
   * @param {Function} cb 回调
   */
  off(eventName, cb) {
    const cbList = this.cb[eventName];
    const index = cbList.findIndex((el) => el === cb);
    cbList.splice(index, 1);
  }

  /**
   * 触发事件
   * @param {string} eventName
   * @param {Object} eventData
   */
  trigger(eventName, eventData) {
    const cbList = this.cb[eventName];
    if (cbList) {
      for (let i = 0; i < cbList.length; i++) {
        const cb = cbList[i];
        if (typeof cb === "function") {
          try {
            cb(eventData);
          } catch (error) {
            const errMessage = `event callback ${eventName} run fail: ${error.message}`;
            error.message = errMessage;
            console.error(error);
            if (typeof window === "undefined") return;
            if (window.GD_SLS_RUM) {
              window.GD_SLS_RUM.addError(error);
            }
          }
        }
      }
    }
  }
}

// 初始化应用的事件
const AppEvent = new SimpleEvent();
export default AppEvent;
